export default {
   changeLang(state, lang) {
      state.language = lang;
   }
}